import { FeatureFlag } from '@mews-commander/enums';
import { BITextKey } from './BITextKey';

export const EXCLUDED_DASHBOARDS = [
    { id: '503d8ab5-e6ac-464a-924d-03faa4ccbefd' },
    { id: 'b647196d-277d-42db-a085-cc9fd020e8ac' },
    { id: 'bb2acff1-aca0-4da7-b670-c74090738e6f' },
    { id: 'ca9a232a-69f2-48bf-9f55-5c67a30dfe3a' },
    { id: '69213a3c-4bc5-46ce-9db2-6a633369c9b1' },
    { id: '7ed0449c-e740-49c1-9a9d-d52f468b4eba', featureFlag: FeatureFlag.westcordCustomMetricsEnabled },
    { id: 'metricsCustomizationsOverview', featureFlag: FeatureFlag.customMetricsOverviewEnabled },
];

export const CUSTOM_CREATORS = {
    Mews: '@mews',
    You: '@you',
    Unknown: '@unknown',
};

export const DEFAULT_GOOD_DATA_LANGUAGE = 'en-US';

export const DASHBOARD_IDS_WITH_ENTERPRISE_FILTER = [
    'managerDailyDashboard',
    'occupancyDashboard',
    'pickupDashboard',
    'revenueDashboard',
    'adrDashboard',
    'revPARDashboard',
];

export const DASHBOARD_IDS_WITH_SERVICE_FILTER = [
    'occupancyDashboard',
    'pickupDashboard',
    'adrDashboard',
    'revPARDashboard',
];

export enum DashboardListTabs {
    All = 'All',
    Curated = 'Curated',
    Custom = 'Custom',
}

export const OOTB_DASHBOARDS = [
    {
        id: 'managerDailyDashboard',
        name: BITextKey.MewsBIDashboardDailySummary,
    },
    {
        id: 'pickupDashboard',
        name: BITextKey.MewsBIDashboardPickup,
    },
    {
        id: 'occupancyDashboard',
        name: BITextKey.MewsBIDashboardOccupancy,
    },
    {
        id: 'revenueDashboard',
        name: BITextKey.MewsBIDashboardRevenue,
    },
    {
        id: 'reservationDataDashboard',
        name: BITextKey.MewsBIDashboardReservations,
    },
    {
        id: 'adrDashboard',
        name: BITextKey.MewsBIDashboardAdr,
    },
    {
        id: 'revPARDashboard',
        name: BITextKey.MewsBIDashboardRevPAR,
    },
    {
        id: 'multipropertyDashboard',
        name: BITextKey.MewsBIDashboardMultiProperty,
    },
] as const;
